import React from 'react';
import {
  DialogContent,
  makeStyles,
  useMediaQuery,
  useTheme,
  Typography,
  Slide,
} from '~/lib/bn-material-ui';
import { BnDialog } from '~/common/bn-dialog';
import OrderCalculator from './order-calculator';
import { BinPathName } from '~/bins/bin-path-name.tsx';
import { useSirenEntity } from '~/utility/BinSentry-ui-utility';

const useStyles = makeStyles((theme) => {
  return {
    titleContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    title: {
      flex: 1,
      fontWeight: 'bold',
    },
    dialogContent: {
      padding: 0,
      height: '100%',
      minHeight: '50vh',
      backgroundColor: theme.palette.gray[20],
    },
  };
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} timeout={60} {...props} />;
});

export default function OrderCalculatorDialog({ open = false, binHref, activeOrderId, onClose }) {
  const styles = useStyles();
  const { entity: binEntity } = useSirenEntity({ href: binHref });
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));

  if (!binHref) { // set to false on modal close
    return null;
  }

  return (
    <BnDialog
      open={open}
      fullScreen={fullScreen}
      fullWidth
      overrideDialogActions
      TransitionComponent={Transition}
      maxWidth='xl'
      onClose={onClose}
      aria-labelledby='order-calculator-title'
      title={(
        <div className={styles.titleContainer}>
          <Typography variant='subtitle2' className={styles.binPathName}>
            <BinPathName binHref={binHref} />
          </Typography>
          <Typography variant='h5' className={styles.title}>
            {binEntity?.properties?.name}
          </Typography>
        </div>
      )}
    >
      <DialogContent className={styles.dialogContent}>
        <OrderCalculator binId={binHref} activeOrderId={activeOrderId} />
      </DialogContent>
    </BnDialog>
  );
}
